import { ApiResponse } from 'mds-ui/app/shared/model/apiresponse';

export class PriestFormationSearchVO {
    formationName: string;
    userName: string;
    pageNo: number;
    pageSize: number;
    instructor: string;
    startDate: Date;
    endDate: Date;

}
export class PriestFormationVO {
    id: number;
    formationName: string;
    instructor: string;
    startDate: Date;
    endDate: Date;
    classHours: string;
    isActive: string;
    enrollCount: number;
    status: string;
    createdBy: string;
    createdTime: Date;
    lastUpdatedBy: string;
    lastUpdatedTime: Date;
}
export class PriestListResponse {
    apiResponseVO: ApiResponse;
    priestFormationVOList: PriestFormationVO[];
    count: number;
}

export class FormationNameDeclare{
    formationName:string;
}